/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	Output,
	Input,
	EventEmitter,
	Self,
	Optional,
	ChangeDetectorRef,
} from '@angular/core';
import { MultiWrapperComponent } from '../multi-wrapper/multi-wrapper.component';
import { TicketEditBaseComponent } from '../ticket-edit-base/ticket-edit-base.component';
import { NgControl } from '@angular/forms';
import { PlanState } from 'src/app/services/plan-state.service';
import { map, takeUntil } from 'rxjs/operators';
import { EditTicketsCombined } from 'src/app/app-data/models/EditTicketsCombined';
import { TicketEditService } from '../../ticket-edit.service';
import { Observable } from 'rxjs';

@Component({
	selector: 'constraint-role-overlay',
	templateUrl: './constraint-role-overlay.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConstraintRoleOverlayComponent extends TicketEditBaseComponent implements OnInit {
	@Input() public assignedProjectMember$: any;
	@Output() public closed: EventEmitter<any> = new EventEmitter();

	public etc: EditTicketsCombined;

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef,
		public planState: PlanState,
		private ticketEditService: TicketEditService
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();

		// TODO: Doing this because we don't have access to the FormGroup in overlays...So manually sub edit data
		this.ticketEditService.combinedEdit$
			.pipe(takeUntil(this.shutdownSubject))
			.subscribe((etc: EditTicketsCombined) => {
				if (etc) {
					this.etc = etc;
					this.internalField.setValue(etc.data.assignedProjectMemberRoleId);
				}
			});

		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val: number) => {
			// this.onChange(val);
			// TODO: Doing this because we don't have access to the FormGroup in overlays...So manually sub edit data
			this.writeModelChangeFromOverlay(val);
		});
	}

	public writeModelChangeFromOverlay(newRole): void {
		this.ticketEditService.markFormAsDirty();
		this.ticketEditService.writeCombinationBackToList(this.etc, { assignedProjectMemberRoleId: newRole });
	}

	public close(): void {
		this.closed.emit();
	}
}
